import * as React from 'react';
import {useSelector} from 'react-redux';

import type {NutshellState} from '../../../../../store';
import {ReportProviderContext} from '../../../../reports/report-provider-context';

import {
    getCurrentReportChartIsLoading,
    getCurrentReportChartData,
    isChartTimedOut,
    isChartErrored,
    getCurrentChatbotReportChartIsLoading,
    isChatbotChartTimedOut,
    isChatbotChartErrored,
    getCurrentChatbotReportChartData,
} from './chat-selectors';

type Props = {
    children: React.ReactNode;
};

export function ChatReportProvider(props: Props) {
    const chartData = useSelector((state: NutshellState) => getCurrentReportChartData(state));
    const isLoading = useSelector((state: NutshellState) => getCurrentReportChartIsLoading(state));
    const isTimedOut = useSelector((state: NutshellState) => isChartTimedOut(state));
    const isErrored = useSelector((state: NutshellState) => isChartErrored(state));

    return (
        // @ts-expect-error
        <ReportProviderContext.Provider value={{chartData, isLoading, isTimedOut, isErrored}}>
            {props.children}
        </ReportProviderContext.Provider>
    );
}

export function ChatbotReportProvider(props: Props) {
    const chartData = useSelector((state: NutshellState) =>
        getCurrentChatbotReportChartData(state)
    );
    const isLoading = useSelector((state: NutshellState) =>
        getCurrentChatbotReportChartIsLoading(state)
    );
    const isTimedOut = useSelector((state: NutshellState) => isChatbotChartTimedOut(state));
    const isErrored = useSelector((state: NutshellState) => isChatbotChartErrored(state));

    return (
        // @ts-expect-error
        <ReportProviderContext.Provider value={{chartData, isLoading, isTimedOut, isErrored}}>
            {props.children}
        </ReportProviderContext.Provider>
    );
}
